module.exports = __webpack_public_path__ + "img/Progress-Report-Process-3-mobile.f320a387.png";